import { FC } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import ContentLoader from '@shared/lib/components/SkeletonContentLoader'

import {
  SKELETON_FOREGROUND_COLOR,
  SKELETON_MAIN_COLOR,
  SKELETON_SPEED,
  SKELETON_STYLES,
} from '@shared/consts/skeleton'

import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

const Skeleton: FC = () => {
  const { isMobile } = useClientResponsive()

  return (
    <BlockBoundary>
      {isMobile ? (
        <ContentLoader
          speed={SKELETON_SPEED}
          backgroundColor={SKELETON_MAIN_COLOR}
          foregroundColor={SKELETON_FOREGROUND_COLOR}
          style={SKELETON_STYLES}
          width={'104px'}
          height={'52px'}>
          <rect rx='16' ry='16' width='104px' height='52px' />
        </ContentLoader>
      ) : (
        <ContentLoader
          speed={SKELETON_SPEED}
          backgroundColor={SKELETON_MAIN_COLOR}
          foregroundColor={SKELETON_FOREGROUND_COLOR}
          style={SKELETON_STYLES}
          width={'130px'}
          height={'164px'}>
          <circle cx='65' cy='65' r='65' />
          <rect x='33' y='146' rx='8' ry='8' width='64px' height='18px' />
        </ContentLoader>
      )}
    </BlockBoundary>
  )
}

export default Skeleton
